import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionImportancePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionImportance.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionImportance.button1'),
          value: 'reduce_food_waste',
        },
        {
          text: t('pages.onboarding.questionImportance.button2'),
          value: 'save_money',
        },
        {
          text: t('pages.onboarding.questionImportance.button3'),
          value: 'eat_healthier',
        },
        {
          text: t('pages.onboarding.questionImportance.button4'),
          value: 'learn_to_cook',
        },
        {
          text: t('pages.onboarding.questionImportance.button5'),
          value: 'something_else',
        },
      ]}
      onSubmit={handleSubmit}
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
